import { makeAutoObservable } from 'mobx';

export const SnackbarService = makeAutoObservable({
  open: false,
  color: 'success',
  text: 'success message',

  setOpenTrue(color, text) {
    this.open = true;
    this.color = color;
    this.text = text;
  },

  setOpenfalse() {
    this.open = false;
  }
});
